module.exports = __webpack_public_path__ + "img/avatar4.0f6e34a6.png";